module.exports = {
  "calendarInteraction": {
    "name": "ui-addon-calendars interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "collapse all-day events",
        "expand all-day events",
        "expand all-day events day header",
        "click view more"
      ],
      "viewType": {
        "type": [
          "LIST",
          "DAY",
          "WEEK",
          "MONTH"
        ]
      },
      "total": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "ui-addon-calendars",
    "version": "1"
  }
};